export enum HttpErrors {
    EmailNotFound = 'EM_NOT_FOUND',
    PasswordsNoMatch = 'PW_MISMATCH',
    Duplicate = 'ER_DUP_ENTRY',
    GenericError = '400',
    InvalidJWT = 'Invalid JWT.'
}

export enum HttpErrorMessage {
    GenericError = 'Whoops, something went wrong! Please try again soon.'
}

export enum StatusCode {
    Ok = 200
}

export enum Industries {
    Cannabis = 'Cannabis',
    Liquor = 'Liquor',
    CPG = 'CPG'
}
